import React from 'react';
import { Form, Select, Input, DatePicker, FormInstance } from 'antd';
import GatewaySelect from '../../common/GatewaySelect';

const Update: React.FC<{
  isEdit?: boolean,
  initialValues?: Partial<GlobalDevice>,
  form: FormInstance
}> = ({ initialValues, form }) => {
  return (
    <Form
      form={form}
      labelCol={{ span: 6 }}
      wrapperCol={{ span: 16 }}
      style={{ maxWidth: 600 }}
      initialValues={initialValues}
      autoComplete="off"
    >
      <Form.Item<GlobalDevice>
        label="设备序列号"
        name="deviceSn"
        rules={[{ required: true }]}
      >
        <Input />
      </Form.Item>
      <Form.Item<GlobalDevice>
        label="ICCID"
        name="iccid"
        rules={[{ required: false }]}
      >
        <Input />
      </Form.Item>
      <Form.Item<GlobalDevice>
        label="网络类型"
        name="type"
        initialValue={'4G'}
        rules={[{ required: true }]}
      >
        <Input disabled />
      </Form.Item>
      <Form.Item<GlobalDevice>
        label="MAC地址"
        name="mac"
        rules={[{ required: true }]}
      >
        <Input placeholder='请输入MAC地址' />
      </Form.Item>
      {/* <Form.Item<GlobalDevice>
        label="展位号"
        name="name"
        rules={[{ required: true }]}
      >
        <Input />
      </Form.Item> */}
      <Form.Item<GlobalDevice>
        label="备注"
        name="description"
      >
        <Input.TextArea />
      </Form.Item>
    </Form>
  );
}

export default Update;